import './Loader.css';
import React from 'react';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader" role="status">
        <span>Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
